export default {
  title: 'Zapłać przez Pix',
  hint: 'Skopiuj kod i wklej go w Pix w aplikacji bankowej lub zeskanuj nim kod QR.',
  copy: 'Kopiuj kod Pix',
  copied: 'Kod skopiowany',
  qr_alt: 'Kod QR Pix',
  expires_in: 'Kod wygasa za {{time}}',
  waiting: 'Potwierdzimy zamówienie, gdy tylko bank wyśle płatność.',
  open_page: 'Otwórz zamiast tego stronę płatności',
  expired: 'Ten kod Pix wygasł. Rozpocznij płatność ponownie, aby otrzymać nowy.',
  cancel: 'Anuluj płatność',
  checking: 'Sprawdzanie płatności…',
  close: 'Zamknij',
};
